<template>
  <div>
    <h3>Care Gap</h3>
  </div>
</template>

<script>
export default {
  setup() {
    return {
      name: 'CareGapContent'
    }
  },
}
</script>